export default __webpack_public_path__ + "static/media/About-1.827c8dc0.jpg";